import React from 'react'
import styled from 'styled-components'
import { isIOS } from 'react-device-detect'
import { useParams, useNavigate } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { addToWishlist } from '../../js/pixelEvent'
import { formatNumberWithTruncation, getParsedSessionStorageItem } from '../../js/script'
import { AFWebLinkType, handlePostMessage, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { postLikeProducts } from '../../api/product'
import { CartBtnRight } from '../../components/product/ProductModal'
import { BtnDetailIcon } from '../../components/Button'
import { useAppContext } from '../provider/AppProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { useMyContext } from '../provider/MyProvider'
import { ProductDetailType, ProductDetailBaseInfo } from '../../@types/product'
import { GTMItems } from '../../@types/dataLayerObject'

interface ProductMobileActionsProps {
  product: ProductDetailType
  productItem?: ProductDetailBaseInfo
  prevItems: GTMItems[]
  wish: boolean
  setWish: React.Dispatch<React.SetStateAction<boolean>>
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
}

// 이미지 경로
const imgURL = '/images'
const ProductMobileActions = ({
  product,
  productItem,
  prevItems,
  wish,
  setWish,
  setIsModal,
}: ProductMobileActionsProps) => {
  const { isAppView } = useAppContext()
  const { isLogin, setIsLogin, hasAccessToken } = useCommonContext()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()

  const param = useParams()
  const navigate = useNavigate()

  const handleWishlistClick = () => {
    if (hasAccessToken) {
      if (product?.categories[0].fullCategoryLabel === '100원샵') {
        alert('100원샵 상품은 찜하기가 안됩니다.')
        return
      } else {
        let likeItem = { like: '', productNo: '' }
        if (wish) {
          if (param.id !== undefined) {
            likeItem = { like: 'N', productNo: param.id }
          }
        } else {
          if (param.id !== undefined) {
            likeItem = { like: 'Y', productNo: param.id }
          }
        }
        postLikeProducts(likeItem)
          .then((res: any) => {
            if (res.data.length !== 0) {
              setWish((prev: boolean) => !prev)
              if (res.data[0].like === 'Y') {
                const productArray: any = []
                product.categories.map((el: any) => {
                  if (el.categories[0].label !== '브랜드') {
                    productArray.push(el)
                  }
                })

                const discount = formatNumberWithTruncation(
                  (product.price?.salePrice - product.price?.immediateDiscountAmt) * 0.1
                )
                const addWishItem = {
                  dataLayer: {
                    event: 'add_to_wishlist',
                    ecommerce: {
                      currency: 'KRW',
                      value: product.price?.salePrice - product.price?.immediateDiscountAmt,
                      pay_back: product.price?.accumulationAmtWhenBuyConfirm,
                      reserve_discount: 0,
                      items: [
                        {
                          item_id: productItem?.productNo,
                          item_name: productItem?.productName,
                          affiliation: '어바웃피싱',
                          item_list_price: product.price?.salePrice,
                          item_selling_price: product.price?.salePrice - product.price?.immediateDiscountAmt,
                          price: product.price?.salePrice - product.price?.immediateDiscountAmt,
                          quantity: 1,
                          item_total_discount: product.price?.immediateDiscountAmt,
                          discount: 0,
                          index: prevItems[0]?.index,
                          item_brand: product.brand?.name,
                          item_category: prevItems[0]?.item_category || productArray[0].categories[0]?.label,
                          item_category2: prevItems[0]?.item_category2 || productArray[0].categories[1]?.label,
                          item_category3: prevItems[0]?.item_category3 || productArray[0].categories[2]?.label,
                          item_variant: undefined,
                          item_list_id: prevItems[0]?.item_list_id || productArray[0]?.categories[1]?.categoryNo,
                          item_list_name: prevItems[0]?.item_list_name || productArray[0]?.categories[1]?.label,
                          promotion_id: prevItems[0]?.promotion_id || '',
                          promotion_name: prevItems[0]?.promotion_name || '',
                        },
                      ],
                    },
                  },
                }
                if (isAppView) {
                  sendSetAppsflyerEvent({
                    eventName: 'add_to_wishlist',
                    eventType: addWishItem.dataLayer.ecommerce,
                  })
                } else {
                  TagManager.dataLayer(addWishItem)
                }
                addToWishlist(
                  productItem?.productNo || 0,
                  productItem?.productName || '',
                  product.price?.salePrice || 0,
                  product.price?.immediateDiscountAmt || 0
                )
                setIsToast(true)
                setToastMessage('찜 리스트에 저장되었습니다.')
                setToastBtnMessage('바로가기')
                setToastEvent(() => () => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                    })
                  } else {
                    navigate('/wishList')
                  }
                })
              } else if (res.data[0].like === 'N') {
                setIsToast(true)
                setToastMessage('찜 리스트에 제외되었습니다.')
                setToastBtnMessage('바로가기')
                setToastEvent(() => () => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                    })
                  } else {
                    navigate('/wishList')
                  }
                })
              }
            }
          })
          .catch((err) => console.log(err))
      }
    } else {
      const app = getParsedSessionStorageItem('app')
      if (app) {
        handlePostMessage({ actionType: 'onSignInInducement' })
      } else {
        setIsToast(true)
        setToastMessage('로그인이 필요한 서비스입니다.')
        setToastBtnMessage('로그인')
        setToastEvent(() => () => setIsLogin(true))
      }
    }
  }

  const handleCartClick = () => {
    if (!product || product?.stock?.stockCnt === 0) {
      setIsToast(true)
      setToastMessage('상품이 품절되었습니다.')
      return
    }
    setIsModal(true)
  }

  const handleBuyClick = () => {
    if (!product || product?.stock?.stockCnt === 0) {
      setIsToast(true)
      setToastMessage('상품이 품절되어 재입고 알림을 설정 할 수 있습니다')
      // NOTE: 재입고 알림 기능은 ProductModal 에서 처리함
    }
    setIsModal(true)
  }

  return (
    <BottomButtons $isIOS={isIOS} $isAppView={isAppView}>
      <BtnDetailIconWrap>
        <BtnDetailIcon onClick={handleWishlistClick}>
          <img src={wish ? `${imgURL}/icon_heart_fill.png` : `${imgURL}/icon_heart_outline.png`} alt='찜하기' />
        </BtnDetailIcon>
        <BtnDetailIcon
          onClick={handleCartClick}
          className={!product || product?.stock?.stockCnt === 0 ? 'disabled' : ''}
          disabled={!product || product?.stock?.stockCnt === 0}
        >
          <img src={`${imgURL}/icon_cart.png`} alt='장바구니' />
        </BtnDetailIcon>
      </BtnDetailIconWrap>
      {!hasAccessToken && product && product?.stock?.stockCnt > 0 && (
        <NPay onClick={handleBuyClick} className={!product || product?.stock?.stockCnt === 0 ? 'disabled' : ''}>
          <img src={`${imgURL}/icon_npay_logo.png`} alt='네이버페이 로고' />
          <p>{!product || product?.stock?.stockCnt === 0 ? '재입고 알림' : '구매'}</p>
        </NPay>
      )}
      <CartBtnRight onClick={handleBuyClick} className={!product || product?.stock?.stockCnt === 0 ? 'disabled' : ''}>
        {!product || product?.stock?.stockCnt === 0 ? '재입고 알림' : '구매하기'}
      </CartBtnRight>
    </BottomButtons>
  )
}

export default ProductMobileActions

// 하단 아이콘 버튼 영역
export const BtnDetailIconWrap = styled.div`
  display: flex;
`
export const BottomButtons = styled.div<{ $isIOS?: boolean; $isAppView?: boolean }>`
  display: flex;
  gap: 12px;
  position: fixed;
  width: 100%;
  padding: ${({ $isIOS, $isAppView }) => ($isIOS && $isAppView ? '12px 20px 28px 12px' : '12px 20px 12px 12px')};
  background: #fff;
  border-top: 1px solid #eaeaea;
  bottom: 0;
  z-index: 20;
`

export const NPay = styled.div`
  width: 100%;
  height: 48px;
  background: #00de5a;
  border: 1px solid #00c851;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  gap: 5px;
  margin-right: -6px;
  & p {
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
  }
  & img {
    width: 52px;
  }
`
